import React, { useState, useEffect } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from './tooltip';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

const ResponsiveTooltip = ({ 
  children, 
  content, 
  side = 'top', 
  align = 'center',
  className,
  ...props 
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    // Use Popover on mobile (click to open/close)
    return (
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          {children}
        </PopoverTrigger>
        <PopoverContent 
          side={side} 
          align={align}
          className={`text-xs p-2 ${className || ''}`}
          {...props}
        >
          {typeof content === 'string' ? <p>{content}</p> : content}
        </PopoverContent>
      </Popover>
    );
  }

  // Use Tooltip on desktop (hover)
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent side={side} className={className} {...props}>
          {typeof content === 'string' ? <p>{content}</p> : content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ResponsiveTooltip;

